module.exports = __webpack_public_path__ + "static/js/1.9f0f2d05.chunk.worker.js"